// Local storage wrapper for scores and game state.

const KEYS = {
  scores: 'quiz_scores_v1',
  played: 'quiz_played_v1',
  emailSubmitted: 'quiz_email_submitted_v1',
};

export function getHighScores() {
  try {
    return JSON.parse(localStorage.getItem(KEYS.scores) || '{}');
  } catch {
    return {};
  }
}

export function recordScore(mode, scope, score, total) {
  const all = getHighScores();
  const key = `${mode}__${scope}`;
  const prev = all[key] || { best: 0, plays: 0, totalCorrect: 0, totalQuestions: 0 };
  all[key] = {
    best: Math.max(prev.best, score),
    plays: prev.plays + 1,
    totalCorrect: prev.totalCorrect + score,
    totalQuestions: prev.totalQuestions + total,
    lastScore: score,
    lastTotal: total,
    lastPlayedAt: Date.now(),
  };
  try { localStorage.setItem(KEYS.scores, JSON.stringify(all)); } catch {}
  return all[key];
}

export function getPlayCount() {
  try { return parseInt(localStorage.getItem(KEYS.played) || '0', 10); } catch { return 0; }
}

export function incrementPlayCount() {
  const next = getPlayCount() + 1;
  try { localStorage.setItem(KEYS.played, String(next)); } catch {}
  return next;
}

export function getBest(mode, scope) {
  return getHighScores()[`${mode}__${scope}`]?.best || 0;
}

export function emailWasSubmitted() {
  try { return localStorage.getItem(KEYS.emailSubmitted) === '1'; } catch { return false; }
}

export function markEmailSubmitted() {
  try { localStorage.setItem(KEYS.emailSubmitted, '1'); } catch {}
}
